import { normalizePhone } from "@commerce-os/utils";
import { z } from "zod";
import { defineEndpoint } from "./endpoint.js";
/**
 * MK-06 (docs/specs/marketing-site.md "Conversion"): the marketing site's "talk to us" form (Enterprise, Contact).
 * Stored for the platform owner, who is told at once; listed in the Super Admin.
 */
const phone = z
    .string()
    .trim()
    .max(32)
    .refine((value) => normalizePhone(value) !== null, "Not a Bangladeshi mobile number");
export const createLeadRequestSchema = z
    .object({
    name: z.string().trim().min(1).max(120),
    business: z.string().trim().min(1).max(120),
    phone,
    email: z.union([z.literal(""), z.email().max(254)]).default(""),
    branches: z.int().min(1).max(10_000).default(1),
    message: z.string().trim().max(1000).default(""),
    /** The page the form was sent from (`/enterprise`, `/bn/contact`). */
    sourcePage: z.string().trim().max(200).default(""),
    /** The Cloudflare Turnstile widget's answer. */
    turnstileToken: z.string().min(1).max(2048),
})
    .strict();
export const leadSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    business: z.string(),
    /** E.164. */
    phone: z.string(),
    email: z.string(),
    branches: z.int(),
    message: z.string(),
    sourcePage: z.string(),
    createdAt: z.iso.datetime(),
});
export const leadListQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(50),
    cursor: z.uuid().optional(),
});
export const leadListSchema = z.object({ data: z.array(leadSchema), nextCursor: z.uuid().nullable() });
export const createLead = defineEndpoint({
    tag: "leads",
    name: "createLead",
    method: "POST",
    path: "/v1/public/leads",
    access: { public: true },
    summary: "A sales enquiry from the marketing site (bot check; a few per IP and hour)",
    body: createLeadRequestSchema,
    status: 204,
    errors: ["BOT_CHECK_FAILED", "RATE_LIMITED"],
});
export const listPlatformLeads = defineEndpoint({
    tag: "platform-admin",
    name: "listPlatformLeads",
    method: "GET",
    path: "/v1/platform/leads",
    access: { platformAdmin: true },
    summary: "Sales enquiries from the marketing site, newest first",
    query: leadListQuerySchema,
    status: 200,
    response: leadListSchema,
});
//# sourceMappingURL=leads.js.map